import './plugins/vue-axios'
import './plugins/v-hotkey'
import './plugins/highcharts'
import './plugins/moment'
import './plugins/vue2-siema'
import './plugins/vue-meta'
import './plugins/i18n'
import './plugins/vue-lodash'
import './plugins/bootstrap-vue'
import './plugins/notifications'
import './plugins/vue-leader-line'
import './plugins/vue-uuid'
import './plugins/v-mask'
// import './components'

import './router/componentHooks'
import App from './App.vue'
import {COUNTRIES_SNG, SERVERS_HOST_LIST} from '@/config'
import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import messages from './messages'
import router from './router'
import store from '@/store'
// import {sync} from 'vuex-router-sync'
import vuetify from './plugins/vuetify'

import i18n from "./helpers/i18n"
// @ts-ignore
import {VueReCaptcha} from "vue-recaptcha-v3";

import {RECAPTCHA_KEY} from "@/config";
Vue.use(VueReCaptcha, { siteKey: RECAPTCHA_KEY })

export const bus = new Vue();


import interceptorsSetup from './helpers/interseptors'
interceptorsSetup()

import barcode from 'tui-vue-barcode'

Vue.component('barcode', barcode)


Vue.config.productionTip = false

/**
 * Базовый URL сервера
 */
Vue.axios.defaults.baseURL = (function (){
    if(localStorage['region'] && COUNTRIES_SNG.includes(localStorage['region'])){
        return SERVERS_HOST_LIST[0]
    }else {
        return SERVERS_HOST_LIST[1]
    }
})()
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.get['Content-Type'] = 'application/json'

/**
 * Локализация
 */

if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang','ru')
  store.commit('locale/SetLang','ru')

} else {
  console.log(localStorage.getItem('lang'))
  store.commit('locale/updateLocale',localStorage.getItem('lang'))
}
// let lang: string | any = store.getters('locale/GetLang')
//
// Vue.axios.defaults.headers.common['LF-Localization'] = lang
// const i18n = new VueI18n({
//   locale: lang,
//   messages,
// })

const access_token = localStorage.getItem('access-token')
const device_uid = localStorage.getItem('device-uid')
if(access_token && device_uid){
  Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
  Vue.axios.defaults.headers.common['LF-Device'] = device_uid
}




new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
